import type { CityConfig } from "../city-template/types";

export const goldenConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Golden",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "golden",
  route: "/golden",
  title: "Emergency Passport Golden, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Golden, Colorado — as fast as 24 hours. Same-day courier processing for Golden, Lakewood, Arvada, Evergreen, and all Jefferson County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Golden, CO",
  heroSubtitle: "Last-minute business trip to London and your passport just expired? Colorado School of Mines study abroad departure coming up and you forgot to renew? We help Golden residents — from Mines students to Lookout Mountain homeowners to Coors brewery employees — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Golden%20Colorado%20scenic%20mountain%20foothills%20with%20the%20iconic%20Coors%20Brewery%20building%20and%20Clear%20Creek%20running%20through%20the%20historic%20downtown%20district%2C%20the%20Table%20Mountain%20mesas%20rising%20behind%20the%20city%20in%20golden%20hour%20light%2C%20charming%20Main%20Street%20with%20Western%20storefronts%20and%20mountain%20views%2C%20the%20Colorado%20School%20of%20Mines%20campus%20nestled%20against%20the%20foothills%2C%20warm%20golden%20sunlight%20bathing%20the%20landscape%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20wide%20cinematic%20view&width=1800&height=700&seq=golden-hero-001&orientation=landscape",
  heroImageAlt: "Golden Colorado with Coors Brewery, Clear Creek, and Table Mountain mesas",
  geoPosition: "39.7555;-105.2211",
  geoPlacename: "Golden, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 25 miles southeast via US-6 and I-25 — about 35 minutes",
  },
  nearbyCitiesZips: [
    { name: "Golden", zips: "80401, 80402, 80403" },
    { name: "Lakewood", zips: "80214, 80215, 80226, 80227, 80228" },
    { name: "Arvada", zips: "80001, 80002, 80003, 80004, 80005" },
    { name: "Wheat Ridge", zips: "80033, 80034" },
    { name: "Evergreen", zips: "80437, 80439" },
    { name: "Idledale", zips: "80453" },
    { name: "Morrison", zips: "80465" },
    { name: "Genesee", zips: "80401" },
    { name: "Lookout Mountain", zips: "80401" },
    { name: "Applewood", zips: "80401" },
    { name: "Littleton", zips: "80120, 80121, 80122, 80123, 80127, 80128" },
    { name: "Westminster", zips: "80003, 80005, 80020, 80021, 80030, 80031, 80035, 80036" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Golden international departures via DEN" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — avoid the Denver agency despite being only 25 miles away" },
    { icon: "ri-flight-takeoff-line", title: "DEN Airport Service", desc: "Same-day courier for Denver International Airport — just 40 miles from Golden" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in Golden, Lakewood, or Arvada" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/denver" },
    { name: "Emergency passport help in Lakewood, CO", route: "/lakewood-co" },
    { name: "Fast passport renewal in Jefferson County", route: "/golden" },
    { name: "Urgent passport services for Arvada and Wheat Ridge", route: "/golden" },
    { name: "Colorado passport services overview", route: "/colorado" },
    { name: "Passport courier services in Boulder and Longmont", route: "/boulder" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Golden remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Although Golden is only 25 miles from the Colorado Passport Agency, our courier service saves you the hassle of appointments, traffic, and the 35-minute drive each way. Let us handle the logistics while you focus on your travel plans.",
  fpcOfficeAddress: "370 17th St, Denver, CO 80202",
  fpcOfficeDistance: "Serving all of Jefferson County, from the foothills to the Denver metro border",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Golden and Jefferson County. From the historic downtown and Clear Creek corridor to the Colorado School of Mines campus, from the foothills communities to the Table Mountain area — we serve every neighborhood in Golden and the surrounding west metro region.",
  nearbyCitiesIntro: "We serve Golden and all nearby Jefferson County communities including Lakewood, Arvada, Wheat Ridge, Evergreen, Morrison, Idledale, and Genesee. We also serve the broader west metro area including Littleton and Westminster.",
  howItWorksIntro: "Most Golden travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — convenient even though the Colorado Passport Agency is only 25 miles away.",
  mistakesIntro: "Golden's unique mix of university students, brewery employees, foothills residents, and international travelers creates distinct passport challenges. Here are the most common mistakes we see from Golden-area travelers.",
  testimonialsIntro: "Golden residents — from Mines students heading abroad to Coors employees traveling for business to foothills families on vacation — trust us when deadlines are tight.",
  faqIntro: "Have questions about expedited passports in Golden, CO? Here are the most common ones we hear from Jefferson County travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Aurora (25 miles, 35 minutes each way)", "Appointment scheduling 2–3 weeks out"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Denver agency drive required — ship from Golden", "Perfect for study abroad, business travel, and vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Golden travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest passport service without the appointment hassle at the Denver agency.",
      bullets: ["24–48 hour turnaround available", "DEN airport departure support", "Study abroad and business travel expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Golden adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Golden or Jefferson County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Golden residents — including Colorado School of Mines students, new Jefferson County residents, and young families.",
      bullets: ["Acceptance facility scheduling in Golden or Lakewood", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Golden residents who lost their passport before international travel — business or personal.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Golden and Jefferson County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Golden and Jefferson County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Golden CO", description: "Urgent passport processing for Golden Colorado travelers with immediate departure needs from DEN." },
    { name: "Expedited Passport Renewal Golden CO", description: "Fast passport renewal for Golden Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Golden CO", description: "New passport application services for Golden Colorado residents applying for their first passport." },
    { name: "Child Passport Golden CO", description: "Minor passport services for Golden Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Chris M.",
      location: "Golden, CO — Downtown",
      rating: 5,
      text: "Had a business trip to Munich with 5 days notice. Fast Passport Center got my renewal done in 3 days. Even though Denver is close, not having to deal with agency appointments and traffic was a huge time saver.",
      service: "Passport Renewal",
    },
    {
      name: "Rachel S.",
      location: "Lakewood, CO",
      rating: 5,
      text: "My son is a Mines student heading to study abroad in Australia. We needed his first passport in under two weeks. Fast Passport Center got it done in 4 days. The document review caught an error that would have caused a rejection.",
      service: "First-Time Passport",
    },
    {
      name: "Mark D.",
      location: "Evergreen, CO",
      rating: 5,
      text: "Family trip to Costa Rica over winter break. Three passports — two renewals and one first-time. Done in 5 business days. Much faster than going through the post office — we had been told 8–11 weeks.",
      service: "Family Passport Bundle",
    },
    {
      name: "Lisa K.",
      location: "Golden, CO — Applewood",
      rating: 5,
      text: "Lost my passport a week before a trip to Paris. Fast Passport Center replaced it in 48 hours. The dedicated agent kept me updated every day — incredible peace of mind when your vacation is on the line.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "gld-1",
      name: "Golden Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "619 12th St",
      city: "Golden",
      state: "CO",
      zip: "80401",
      phone: "(303) 279-2361",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Downtown Golden, near Washington Avenue",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Golden acceptance facility. Good availability compared to mountain locations. Appointments recommended — book 1–2 weeks ahead during Mines school year.",
      icon: "ri-mail-line",
    },
    {
      id: "gld-2",
      name: "Jefferson County Clerk — Golden",
      type: "County Clerk Passport Acceptance",
      address: "100 Jefferson County Pkwy",
      city: "Golden",
      state: "CO",
      zip: "80419",
      phone: "(303) 271-8166",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Jefferson County Administration Building, near the county government campus",
      website: "https://www.jeffco.us/",
      websiteLabel: "Jefferson County Clerk",
      notes: "County clerk with extended hours — one of the best passport acceptance options in the metro area. Full-service facility. Good for complex applications.",
      icon: "ri-government-line",
    },
    {
      id: "gld-3",
      name: "Lakewood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10799 W Alameda Ave",
      city: "Lakewood",
      state: "CO",
      zip: "80226",
      phone: "(303) 989-8072",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Lakewood, approximately 5 miles southeast of Golden",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest acceptance facility in Jefferson County. Best appointment availability in the area. Extended hours until 5PM. Good for busy professionals.",
      icon: "ri-mail-line",
    },
    {
      id: "gld-4",
      name: "Arvada Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5885 Allison St",
      city: "Arvada",
      state: "CO",
      zip: "80004",
      phone: "(303) 421-4293",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Arvada, approximately 8 miles northeast of Golden",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Good alternative for northern Jefferson County residents. Arvada is the most populous city in Jefferson County — book appointments early due to high demand.",
      icon: "ri-mail-line",
    },
    {
      id: "gld-5",
      name: "Wheat Ridge Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10790 W 38th Ave",
      city: "Wheat Ridge",
      state: "CO",
      zip: "80033",
      phone: "(303) 424-4165",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Wheat Ridge, approximately 6 miles east of Golden",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Smaller facility serving Wheat Ridge and eastern Golden. Good backup option when other Jefferson County locations are booked.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 25-mile drive to Aurora on I-25", fpc: "No — ship from Golden" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Denver Traffic", agency: "I-25 and 6th Avenue rush hour delays", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Assuming the Denver Agency Is Easy to Visit",
      description: "The Colorado Passport Agency is only 25 miles from Golden, but appointments are required and book 2–3 weeks out. Life-or-death emergencies only. For most travelers, our courier service is faster and more convenient than trying to get an agency appointment.",
    },
    {
      icon: "ri-book-open-line",
      title: "Study Abroad Deadline Mismanagement",
      description: "Colorado School of Mines sends hundreds of students abroad each year. Passport applications spike in September–October and February–March. Mines students should start the passport process at least 8 weeks before program deadlines.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photos",
      description: "Multiple photo options exist around Golden (Walgreens, UPS Store, Costco in Lakewood) but not all produce compliant photos. Passport photos must be 2×2 inches on a white background with specific head size requirements.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Not Using Extended Jefferson County Clerk Hours",
      description: "Many Golden residents don't realize the Jefferson County Clerk offers passport acceptance with extended hours (8AM–5PM) — much better than typical post office hours. However, appointments still fill quickly.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "International travel requires at least 6 months of passport validity beyond your return date. Many Golden travelers discover expired or near-expired passports just weeks before departure.",
    },
    {
      icon: "ri-flight-takeoff-line",
      title: "Not Confirming Full Itinerary Passport Requirements",
      description: "Golden is just 40 miles from DEN, Colorado's primary international airport. But transit countries and layovers may have their own passport requirements. Always verify the full itinerary, not just the final destination.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Golden or Jefferson County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Golden, Lakewood, or Arvada." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — catching errors before they cause rejections and delays." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no 25-mile Denver drive or agency appointment needed." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Golden address — fast and trackable." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Golden, CO?", a: "Fast Passport Center offers emergency passport processing in Golden, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to make the 25-mile drive to the Colorado Passport Agency or fight for a rare appointment slot." },
    { q: "Is it faster to just drive to the Colorado Passport Agency from Golden?", a: "Not necessarily. The Colorado Passport Agency (25 miles away in Aurora) requires appointments booked 2–3 weeks in advance and only handles life-or-death emergencies. For most travelers, our courier service delivers your passport faster than you could get an agency appointment — and you never leave Golden." },
    { q: "Can you help Colorado School of Mines students with study abroad passports?", a: "Absolutely. Fast Passport Center has extensive experience helping Mines students get passports for study abroad programs. We understand the tight timelines and specific documentation requirements. We can also help international students with passport-related needs." },
    { q: "Does Fast Passport Center serve all of Jefferson County?", a: "Yes. Fast Passport Center serves all of Jefferson County including Golden, Lakewood, Arvada, Wheat Ridge, Evergreen, Morrison, Conifer, Genesee, Idledale, and all foothills communities. Our courier service works the same everywhere — no driving required." },
    { q: "What if I live in Evergreen or the foothills?", a: "Foothills residents face unique challenges with limited local services. Fast Passport Center is perfect — ship your documents from the UPS Store in Evergreen or Golden, and we handle the rest. No need to drive down to Denver or deal with mountain winter conditions for passport services." },
    { q: "How much does an expedited passport cost in Golden, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Golden?", a: "Walgreens (17222 S Golden Rd), UPS Store (17121 S Golden Rd), and the Costco in Lakewood all offer passport photo services. The Jefferson County Clerk's office may also provide photo services. Always confirm your photos meet the strict 2×2 inch white background requirements." },
    { q: "Do you serve the Coors and Molson Coors employees in Golden?", a: "Yes. Fast Passport Center serves all Golden businesses and their employees, including Molson Coors Beverage Company headquarters staff. We understand the needs of corporate travelers and can coordinate expedited service around business travel schedules." },
  ],
  photoLocations: [
    { name: "Walgreens — Golden", address: "17222 S Golden Rd, Golden, CO 80401", hours: "Mon–Sun: 8AM–9PM", website: "https://www.walgreens.com/" },
    { name: "UPS Store — Golden", address: "17121 S Golden Rd, Golden, CO 80401", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/" },
    { name: "Walgreens — Lakewood", address: "1555 Quail St, Lakewood, CO 80215", hours: "Mon–Sun: 8AM–9PM", website: "https://www.walgreens.com/" },
    { name: "Costco — Lakewood", address: "8686 Park Meadows Center Dr, Lone Tree, CO 80124", hours: "Mon–Fri: 10AM–8:30PM, Sat: 9:30AM–6PM, Sun: 10AM–6PM", website: "https://www.costco.com/" },
  ],
  dmvLocations: [
    { name: "DMV — Golden (Jefferson County)", address: "2099 Wadsworth Blvd, Lakewood, CO 80214", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV for Jefferson County residents. REAL ID and driver's license renewals. Approximately 5 miles from Golden. The Jefferson County motor vehicle office.", featured: true },
    { name: "DMV — Wheat Ridge", address: "10140 W 44th Ave, Wheat Ridge, CO 80033", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV for northern Jefferson County residents. REAL ID processing available. Approximately 7 miles from Golden.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "40 miles east of Golden via US-6 and Pena Blvd",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport. Approximately 45-minute drive from Golden in normal traffic. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. The closest international airport for Golden and Jefferson County residents.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "BJC",
      name: "Rocky Mountain Metropolitan Airport",
      distance: "10 miles northeast of Golden via CO-128",
      address: "11755 Airport Way, Broomfield, CO 80021",
      note: "General aviation and corporate airport serving the north metro area. No commercial passenger service. Convenient for private jet and corporate travel departures.",
      flightUrl: "https://www.flyrmma.com/",
      flightLabel: "BJC Flight Info",
      featured: false,
    },
    {
      code: "COS",
      name: "Colorado Springs Airport",
      distance: "85 miles south of Golden via I-25",
      address: "7770 Milton E Proby Pkwy, Colorado Springs, CO 80916",
      note: "Alternative airport with domestic service. Approximately 1.5-hour drive from Golden. Good option when DEN flights are limited or weather-affected.",
      flightUrl: "https://www.flycos.com/",
      flightLabel: "COS Flight Info",
      featured: false,
    },
  ],
};